export const getShareUrl = (path: string) => {
  return `${window.location.origin}${path.startsWith('/') ? path : `/${path}`}`
}
